import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import useAsyncData from '../hooks/useAsyncData';
import useStaleWarning from '../hooks/useStaleWarning';
import useAutoRefresh from '../hooks/useAutoRefresh';

const ScrumctlDisplay = () => {
  const { data: status, loading, error, retry } = useAsyncData('/api/scrumctl/status');
  const { isStale, lastUpdated } = useStaleWarning(status);
  useAutoRefresh(retry);

  const fmtTime = (d) => d ? d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '–';

  if (loading) {
    return (
      <ErrorBoundary>
        <section className="panel scrumctl-panel" aria-label="Scrumctl status" aria-busy="true">
          <h2>Scrumctl</h2>
          <div className="skeleton">
            <div className="skeleton-line" />
            <div className="skeleton-line" />
          </div>
        </section>
      </ErrorBoundary>
    );
  }
  if (error) {
    return (
      <ErrorBoundary>
        <section className="panel scrumctl-panel" aria-label="Scrumctl status" aria-live="assertive">
          <h2>Scrumctl</h2>
          <p className="error-msg">Failed to load scrumctl status.</p>
          <button type="button" className="btn-retry" onClick={retry}>Retry</button>
        </section>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <section className="panel scrumctl-panel" aria-label="Scrumctl status" aria-busy="false">
        <div className="panel-header">
          <h2>Scrumctl</h2>
          <div className="panel-meta">
            <span className="last-updated" aria-label="Last updated">
              Last updated: {fmtTime(lastUpdated)}
            </span>
            {isStale && (
              <span className="badge badge-stale" role="status" aria-live="polite">Stale</span>
            )}
            <button type="button" className="btn-icon btn-refresh" onClick={retry} aria-label="Refresh scrumctl">
              ↻
            </button>
          </div>
        </div>
        {status && (
          <table className="scrumctl-table" aria-label="Scrumctl status details">
            <tbody>
              {Object.entries(status).map(([key, val]) => (
                <tr className="scrumctl-row" key={key}>
                  <th scope="row">{key}</th>
                  <td>{String(val)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </ErrorBoundary>
  );
};

export default ScrumctlDisplay;
